import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";
import { ChapterHead } from "./ChapterHead";

const Stars = () => (
    <div className="flex gap-0.5 text-[#f23218]">
        {[...Array(5)].map((_, i) => (
            <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
        ))}
    </div>
);

export const Reviews = ({ t }) => (
    <section data-testid="reviews-section" className="relative overflow-hidden bg-[#f23218] py-20 sm:py-28">
        <div className="grain absolute inset-0" />
        <span aria-hidden className="font-display pointer-events-none absolute -right-4 bottom-0 z-0 select-none text-[16rem] font-black leading-none text-[rgba(27,11,6,0.12)] sm:text-[22rem]">03</span>
        <div className="relative mx-auto max-w-7xl px-5 sm:px-6">
            <ChapterHead dark chapter={t.reviews.chapter} label={t.reviews.label} title={t.reviews.title} />
            <div className="grid gap-10 lg:grid-cols-[320px_1fr] lg:gap-14">
                <motion.div
                    initial={{ opacity: 0, scale: 0.94 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    data-testid="reviews-score-card"
                    className="flex flex-col items-start justify-center rounded-3xl bg-[#1b0b06] p-8 text-[#fbf3e8] shadow-2xl"
                >
                    <div className="flex items-end gap-3">
                        <span className="font-display text-7xl font-black leading-none text-[#faff00] sm:text-8xl">{t.reviews.score}</span>
                        <span className="pb-2 text-sm font-semibold text-[#fbf3e8]/70">{t.reviews.of}</span>
                    </div>
                    <div className="mt-4 flex gap-1 text-[#faff00]">
                        {[...Array(5)].map((_, i) => (
                            <Star key={i} size={20} fill="currentColor" strokeWidth={0} />
                        ))}
                    </div>
                    <p className="mt-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#fbf3e8]/60">
                        <BadgeCheck size={14} className="text-[#f23218]" />
                        Google · {t.reviews.count}
                    </p>
                </motion.div>
                <div className="grid gap-4 sm:grid-cols-2">
                    {t.reviews.list.map((r, i) => (
                        <motion.blockquote
                            key={r.name}
                            initial={{ opacity: 0, y: 26 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.55, delay: i * 0.07 }}
                            data-testid={`review-card-${i}`}
                            className="flex flex-col justify-between rounded-2xl bg-[#fbf3e8] p-5 shadow-lg transition-transform hover:-translate-y-1"
                        >
                            <div>
                                <Stars />
                                <p className="mt-3 text-sm leading-relaxed text-[#1b0b06]/85">“{r.text}”</p>
                            </div>
                            <footer className="mt-4 text-xs font-extrabold uppercase tracking-wider text-[#f23218]">— {r.name}</footer>
                        </motion.blockquote>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
